.header {
    color: var(--secondary-sidebar-text);
    font-size: 11px;
    line-height: 14px;
    text-transform: uppercase;
    padding: 0 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid var(--secondary-sidebar-hover-blue);
}

.popover {
    background-color: var(--sidebar-secondary);
    width: 309px;
    height: 400px;
    border-radius: 8px;
    padding: 8px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 2px;
    box-sizing: border-box;
}
